import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

import Login from './pages/Login';
import ContraSenha from './pages/ContraSenha';
import Ocorrencia from './pages/Ocorrencia';
import SenhasList from './pages/SenhasList';
import SenhaForm from './pages/SenhaForm';
import RequireMaster from './components/RequireMaster';

import IsLogged from './components/IsLogged';


export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/gerar" element={<IsLogged><ContraSenha /></IsLogged>} />
          <Route path="/ocorrencias" element={<IsLogged><Ocorrencia /></IsLogged>} />

          {/* apenas master/admin */}
          <Route path="/senhas" element={<RequireMaster><SenhasList /></RequireMaster>} />
          <Route path="/senhas/novo" element={<RequireMaster><SenhaForm /></RequireMaster>} />
          <Route path="/senhas/:id" element={<RequireMaster><SenhaForm /></RequireMaster>} />

          <Route path="/" element={<Navigate to="/gerar" replace />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}
